import { render, staticRenderFns } from "./GenaralUserMaster.vue?vue&type=template&id=1ce2c709"
import script from "./GenaralUserMaster.vue?vue&type=script&setup=true&lang=ts"
export * from "./GenaralUserMaster.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports